/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compliance_Link_Cancellation_PolicyInputs */

const tr_pricing_compliance_link_cancellation_policy = /** @type {(inputs: Pricing_Compliance_Link_Cancellation_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İptal ve Fesih Politikası`)
};

const en_pricing_compliance_link_cancellation_policy = /** @type {(inputs: Pricing_Compliance_Link_Cancellation_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellation and Termination Policy`)
};

const de_pricing_compliance_link_cancellation_policy = /** @type {(inputs: Pricing_Compliance_Link_Cancellation_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornierungs- und Kündigungsbedingungen`)
};

const ru_pricing_compliance_link_cancellation_policy = /** @type {(inputs: Pricing_Compliance_Link_Cancellation_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика отмены и расторжения`)
};

/**
* | output |
* | --- |
* | "Cancellation and Termination Policy" |
*
* @param {Pricing_Compliance_Link_Cancellation_PolicyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compliance_link_cancellation_policy = /** @type {((inputs?: Pricing_Compliance_Link_Cancellation_PolicyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compliance_Link_Cancellation_PolicyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_compliance_link_cancellation_policy(inputs)
	if (locale === "de") return de_pricing_compliance_link_cancellation_policy(inputs)
	if (locale === "ru") return ru_pricing_compliance_link_cancellation_policy(inputs)
	return tr_pricing_compliance_link_cancellation_policy(inputs)
});